module.exports = __webpack_public_path__ + "img/web5.bee96448.png";